import React from 'react';
import { ASELLER_MARK_COLORS } from '../theme/brandColors';

/**
 * Знак платформы Aseller (зелёная и синяя дуги) — на кнопках входа через платформу.
 * Безликая иконка «войти» не говорит, КУДА ведёт кнопка; знак говорит.
 */
const AsellerMark: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg viewBox="0 0 40 40" width={size} height={size} aria-hidden="true" focusable="false">
    <path d="M7 23C7 11 28 5 35 14" stroke={ASELLER_MARK_COLORS.green} strokeWidth="5" fill="none" strokeLinecap="round" />
    <path d="M5 25C12 36 31 35 36 22" stroke={ASELLER_MARK_COLORS.blue} strokeWidth="5" fill="none" strokeLinecap="round" />
    <circle cx="35.5" cy="15.5" r="2.6" fill={ASELLER_MARK_COLORS.yellow} />
  </svg>
);

export default AsellerMark;
